import styled from 'styled-components';

import fonts from '../../../theme/fonts';

export const Container = styled.div`
    left: 0;
    position: fixed;
    right: 0;
    top: 24px;
    pointer-events: none;
    z-index: 10001;
`;

export const SnackBarContainer = styled.div`
    margin-left: auto;
    margin-right: auto;
    max-width: 432px;
    padding-left: 24px;
    padding-right: 24px;
`;

export const InnerContent = styled.div`
    background-color: ${(props) => props.theme.black};
    border-radius: 12px;
    box-shadow: 0 8px 8px rgba(20, 20, 20, 0.16);
    color: ${(props) => props.theme.white};
    padding: 16px 24px;
    pointer-events: initial;
    cursor: pointer;
    font-family: ${fonts.regular};
`;
